

















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { formatToYMDDate } from "@/utility/DateUtils";
import RujukanSvc from "@/services/bridgingVclaim/Rujukan";
import InputSEP from "@/pages/PendaftaranPage/InputSEP.vue";
import InputSRK from "@/pages/PendaftaranPage/InputSRK.vue";
import InputSPRI from "@/pages/PendaftaranPage/InputSPRI.vue";
import RiwayatSEP from "@/pages/PendaftaranPage/RiwayatSEP.vue";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import InputRujukan from "./InputRujukan.vue";
import PengajuanSepModal from "@/pages/PendaftaranPage/PengajuanSepModal.vue";
import storePeserta from "@/store/modules/bridgingVclaim/Peserta";
import { BpjsPesertaInterface } from "@/types/bpjs_peserta";

@Component({
  components: {
    InputSEP,
    RiwayatSEP,
    InputSRK,
    InputSPRI,
    InputRujukan,
    PengajuanSepModal
  }
})
export default class SEPTabView extends Vue {
  today = new Date().toISOString().substr(0, 10);
  ppkPelayanan = "1205R001";
  asalRujukan = "1";
  searchType = "2";
  typeOptions = [
    { id: "1", name: "No Kartu" },
    { id: "2", name: "No Rujukan" }
  ];
  placeholderCari = "Masukkan Nomor Rujukan";
  asalRujukanOptions = [
    { id: "1", name: "Faskes 1" },
    { id: "2", name: "Faskes 2 (RS)" }
  ];
  noSuket = "";
  dpjpSuket = ""; // kode dokter bpjs
  ppkRujukan = "";
  ppKRujukanOptions = [
    { id: "0177B016", name: "Klinik Pratama Anugerah" },
    { id: "0177B017", name: "Klinik Madukismo" }
  ];
  diagAwal = "";
  unitTujuan = "";
  dpjpSep = ""; // kode dokter bpjs
  jnsPelayanan = "2";
  jnsPelayananOptions = [
    { kode: "1", name: "Rawat Inap" },
    { kode: "2", name: "Rawat Jalan" }
  ];
  kelasHak = "3";
  kelasHakOption = [
    { kode: "1", name: "Kelas 1" },
    { kode: "2", name: "Kelas 2" },
    { kode: "3", name: "Kelas 3" }
  ];
  // 1. VVIP, 2. VIP, 3. Kelas 1, 4. Kelas 2, 5. Kelas 3, 6. ICCU, 7. ICU
  kelasNaik = "5";
  kelasNaikOption = [
    { id: "1", name: "VVIP" },
    { id: "2", name: "VIP" },
    { id: "3", name: "Kelas 1" },
    { id: "4", name: "Kelas 2" },
    { id: "5", name: "Kelas 3" },
    { id: "6", name: "ICCU" },
    { id: "7", name: "ICU" }
  ];
  pembiayaan;
  pembiayaanOption = [
    { id: "1", name: "Pribadi" },
    { id: "2", name: "Pemberi Kerja" },
    { id: "3", name: "Asuransi Kesehatan Tambahan" }
  ];
  pjPembiayaan;
  eksekutif = "0";
  yesNoOptions = [
    { id: "0", name: "Tidak" },
    { id: "1", name: "Ya" }
  ];
  cob = "0";
  katarak = "0";
  catatan = "";
  tglRujukan = formatToYMDDate(new Date());
  noRujukan = "";
  tglSep = formatToYMDDate(new Date());
  tujuanKunjungan = "0";
  tujuanKunjunganOptions = [
    { id: "0", name: "Normal" },
    { id: "1", name: "Prosedur" },
    { id: "2", name: "Konsul Dokter" }
  ];
  flagProsedurOptions = [
    { id: "0", name: "Prosedur Tidak Berkelanjutan" },
    { id: "1", name: "Prosedur dan Terapi Berkelanjutan" }
  ];
  penunjangOptions = [
    { id: "1", name: "Radioterapi" },
    { id: "2", name: "Kemoterapi" },
    { id: "3", name: "Rehabilitasi Medik" },
    { id: "4", name: "Rehabilitasi Psikososial" },
    { id: "5", name: "Transfusi Darah" },
    { id: "6", name: "Pelayanan Gigi" },
    { id: "7", name: "Laboratorium" },
    { id: "8", name: "USG" },
    { id: "9", name: "Farmasi" },
    { id: "10", name: "Lain-Lain" },
    { id: "11", name: "MRI" },
    { id: "12", name: "HEMODIALISA" }
  ];
  asesmenOptions = [
    { id: "1", name: "Poli spesialis tidak tersedia pada hari sebelumnya" },
    { id: "2", name: "Jam Poli telah berakhir pada hari sebelumnya" },
    {
      id: "3",
      name: "Dokter Spesialis yang dimaksud tidak praktek pada hari sebelumnya"
    },
    { id: "4", name: "Atas Instruksi RS" },
    { id: "5", name: "Tujuan Kontrol" }
  ];
  KllOptions = [
    { id: "0", name: "Bukan Kecelakaan lalu lintas [BKLL]" },
    { id: "1", name: "KLL dan bukan kecelakaan Kerja [BKK]" },
    { id: "2", name: "KLL dan KK" },
    { id: "3", name: "KK" }
  ];
  noRm = "";

  responseVclaim = null;
  messageVclaim = "";
  warningDialogText = "";
  showWarningDialog = false;

  searchRujukanKey = "";
  searchRujukanType = "1";
  loadingSearchRujukan = false;
  pengajuanSepShowed = false;

  get sep() {
    return storeSEP.sep;
  }

  get riwayatSep() {
    return storeSEP.riwayatSEP;
  }

  get noka() {
    return this.responseVclaim?.rujukan?.peserta?.noKartu ?? null;
  }

  get requestData() {
    return {
      noKartu: "", //no kartu bpjs
      tglSep: this.tglSep,
      ppkPelayanan: this.ppkPelayanan,
      jnsPelayanan: this.jnsPelayanan,
      klsRawat: {
        klsRawatHak: this.kelasHak,
        klsRawatNaik: this.kelasNaik,
        pembiayaan: this.pembiayaan,
        penanggungJawab: this.pjPembiayaan
      },
      noMR: this.noRm,
      rujukan: {
        asalRujukan: this.asalRujukan,
        tglRujukan: this.tglRujukan,
        noRujukan: this.noRujukan,
        ppkRujukan: this.ppkRujukan
      },
      catatan: this.catatan,
      diagAwal: this.diagAwal,
      poli: {
        tujuan: this.unitTujuan,
        eksekutif: this.eksekutif
      },
      cob: {
        cob: this.cob
      },
      katarak: {
        katarak: this.katarak
      },
      jaminan: {
        lakaLantas: "0",
        penjamin: {
          tglKejadian: "",
          keterangan: "",
          suplesi: {
            suplesi: "0",
            noSepSuplesi: "",
            lokasiLaka: {
              kdPropinsi: "",
              kdKabupaten: "",
              kdKecamatan: ""
            }
          }
        }
      },
      tujuanKunj: this.tujuanKunjungan,
      flagProcedure: "",
      kdPenunjang: "",
      assesmentPel: "",
      skdp: {
        noSurat: this.noSuket,
        kodeDPJP: this.dpjpSuket
      },
      dpjpLayan: this.dpjpSep,
      noTelp: "081111111101",
      user: "Coba Ws"
    };
  }

  get todayDate() {
    return moment().format("YYYY-MM-DD");
  }

  get dataPeserta() {
    return storePeserta;
  }

  get peserta(): BpjsPesertaInterface {
    return storePeserta.peserta;
  }

  @Watch("peserta", { deep: true })
  changePeserta(pst) {
    if (pst) {
      this.searchRujukanKey = pst.noKartu;
      this.searchType = "1";

      this.getRujukan();

      const param = {
        nomor: pst.noKartu,
        tgl_awal: "2022-01-01",
        tgl_akhir: this.today
      };
      storeSEP.act_riwayat_sep(param);
    } else {
      console.log("peserta null");
      this.responseVclaim = null;
      storeSEP.act_clear_riwayat_sep();
    }
  }

  async getRujukan() {
    if (!this.loadingSearchRujukan) {
      this.loadingSearchRujukan = true;
      this.responseVclaim = null;
      storeSEP.act_clear_riwayat_sep();

      let service = null;

      if (this.searchType == "1") {
        service = RujukanSvc.getByNoka(
          this.searchRujukanType,
          this.searchRujukanKey
        );
      } else {
        service = RujukanSvc.getByNoRujukan(
          this.searchRujukanType,
          this.searchRujukanKey
        );
      }

      const resp = await service;
      this.loadingSearchRujukan = false;

      this.responseVclaim = resp.data;
      this.messageVclaim = resp.message;

      // if (resp.data?.peserta) {
      //   storePeserta.SET_PESERTA(resp.data.peserta);
      // }

      if (resp.status != 1) {
        appModule.sendErrorAlert(resp.message);
        this.loadingSearchRujukan = false;
        this.warningDialogText = resp.message;
        this.showWarningDialog = true;
      }
      // let param = {};

      // if (this.searchType == "1") {
      //   param = {
      //     nomor: this.searchRujukanKey,
      //     tgl_awal: "2022-01-01",
      //     tgl_akhir: this.today,
      //   };
      //   // storeSEP.act_riwayat_sep(param);
      // } else {
      //   if (this.responseVclaim) {
      //     param = {
      //       nomor: this.responseVclaim.rujukan.peserta.noKartu,
      //       tgl_awal: "2022-01-01",
      //       tgl_akhir: this.today,
      //     };
      //     // storeSEP.act_riwayat_sep(param);
      //   }
      // }
    }
  }

  @Watch("searchType")
  cekNaik(val) {
    storeSEP.act_clear_riwayat_sep();
    this.searchRujukanKey = "";
    this.searchRujukanType = "1";
    this.loadingSearchRujukan = false;
    this.responseVclaim = null;
    if (val == "1") {
      this.placeholderCari = "Masukkan Nomor Kartu";
    } else {
      this.placeholderCari = "Masukkan Nomor Rujukan";
    }
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD-MM-YYYY") : "";
  }

  panelSrk() {
    storeSEP.act_get_sep(this.sep["noSep"]);
  }

  panelSpri() {
    storeSEP.act_get_sep(this.sep["noSep"]);
  }

  showPengajuanSepModal() {
    this.pengajuanSepShowed = true;
  }
}
